import { CreateUserModel } from './create-user-model';

export type AccountInfo = Pick<
    CreateUserModel,
    | 'firstName'
    | 'lastName'
    | 'emailOrPhoneNumber'
    | 'receivesNotifications'
    | 'acceptedPrivacyPolicy'
>;
